// add 'animate' class onto blocks
var headerEle = document.getElementById('header');
var blockEles = document.getElementsByClassName('animate');
var bodyObj = document.getElementsByTagName("body")[0];
var domHeight = (window.innerHeight || document.documentElement.clientHeight);
var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

// simplify the animations for IE11
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
var ua = window.navigator.userAgent;
var edge = ua.indexOf('Edge/');
if (isIE11 || edge > 0) {
    bodyObj.classList.add('ie-anims');
} 
if (edge > 0) {
    bodyObj.classList.add('ie-edge-anims');
}

// header vars
var bannerObj = document.getElementsByClassName('banner')[0];
var bannerContentObj = document.getElementsByClassName('banner-content')[0];
var bannerContentWrapObj = document.querySelectorAll('.banner-content .wrap')[0];
var headerBgWrapObj = document.getElementsByClassName('header-bg-wrap')[0];
var headerBgElesObj = document.getElementsByClassName('side-animate');
var headerBgMiddleEleObj = document.getElementsByClassName('middle-side-inner')[0];

// lcp vars
var lastLcpBlock = document.querySelectorAll('.animate.lcp.fcp');
var lcpBlocks = blockEles;

// load functions
processLcpBlocks();
animateHeader();

function processLcpBlocks() {
    
    // anchor links
    if (lcpBlocks) {
        var sizeTotal = 0;
        var largestItem = 0;
        var sizeTmp = 0;
        var sizeTempHeight = 0;
        var sizeTempWidth = 0;
        var tempBounds = 0;
        for (var i = 0; i < lcpBlocks.length; i++) {
            sizeTempHeight = lcpBlocks[i].clientHeight;
            tempBounds = lcpBlocks[i].getBoundingClientRect();
            sizeTempWidth = lcpBlocks[i].clientWidth;

            // if in viewport
            if (tempBounds.top <= domHeight) {
                lcpBlocks[i].classList.add('visible');
                // if bigger than last biggest element
                if (sizeTmp > sizeTotal) {
                    sizeTotal = sizeTmp;
                    largestItem = i;
                }
            }
        }
        if (largestItem > -1 && lcpBlocks.length) {
            lcpBlocks[largestItem].classList.add('fmp');
        }
        
        // animate blocks after processing
        animateBlocks();
    }
}

/* scroll */
window.addEventListener('scroll', function() {

    // header management
    animateHeader();

    // animate blocks
    animateBlocks();

});

/* resize */
window.addEventListener('resize', function() {

    // reset class on body
    bodyObj.classList.remove('banner-tall-content');

    // header management
    animateHeader();

    // proccess + animate blocks
    processLcpBlocks();

});

/* load */
window.addEventListener('load', function() {
    
    // anchor links
    scrollToTarget(window.location.hash);

});

// animate header
function animateHeader(){
    if (bannerContentObj && headerEle.classList.contains('style-featured')) {

        // added tall-content class when content oversize bg
        var bannerContentHeight = bannerContentObj.clientHeight;
        var bannerContentHeightInner = bannerContentWrapObj.clientHeight;

        if (bannerContentHeightInner > 600) { // the height of the triangle is 600
            bodyObj.classList.add('banner-tall-content');
        }

        var headerBgMiddleEleOffset = 0;
        var headerBgWrapEle = headerBgWrapObj;
        var headerBgEles = headerBgElesObj;
        var headerBgMiddleEle = headerBgMiddleEleObj;
        var headerBgMaxOffset = headerEle.clientHeight;
        
        var scrollPosY = window.pageYOffset || document.documentElement.scrollTop;
        var bannerTopOffset = bannerObj ?
            parseInt(window.getComputedStyle(bannerObj, null).getPropertyValue('padding-top').replace("px", '')) :
            0;
        var headerOffsetBg = scrollPosY + headerBgMaxOffset - bannerContentHeight - bannerTopOffset;
        var headerOffsetBgInner = scrollPosY + headerBgMaxOffset - bannerContentHeight - bannerTopOffset - headerBgMaxOffset;
        var headerExtraClass = false;

        // default to max if over
        if (headerOffsetBg > headerBgMaxOffset) {
            headerOffsetBg = headerBgMaxOffset;
            headerExtraClass = true;
        }
        if (headerOffsetBgInner > headerBgMaxOffset) {
            headerOffsetBgInner = headerBgMaxOffset;
            headerExtraClass = true;
        }
        // default to 0 if gone past 0 (negative)
        if (headerOffsetBg < 0) {
            headerOffsetBg = 0;
        }
        if (headerOffsetBgInner < 0) {
            headerOffsetBgInner = 0;
        }

        // set height of bg to the height of the header (this doesn't change)
        headerBgWrapEle.setAttribute("style", "height: " + headerBgMaxOffset + 'px');
        // transform Y the offset of the middle element with the SVG shape as a mask
        headerBgMiddleEle.setAttribute("style", "transform: translateY(-" + headerOffsetBgInner + 'px);');
        // loop the side animate styles and move these up
        for (var i = 0; i < headerBgEles.length; i++) {
            headerBgEles[i].setAttribute("style", "transform: translateY(-" + headerOffsetBg + 'px);');
        }

        // toggle class when done with transition
        if (headerExtraClass === true) {
            headerEle.classList.add('shadow');
        } else {
            headerEle.classList.remove('shadow');
        }

    }
}

// animate block
function animateBlocks(delayOffset = 0) {
    var delayCounter = delayOffset;
    var domNegate = (domHeight/8);
    if (domNegate > 100) {
        domNegate = 100;
    }
    for (var i = 0; i < blockEles.length; i++) {
        var domBounds = blockEles[i].getBoundingClientRect();
        // don't override current styles
        var currentStyles = blockEles[i].getAttribute('style');
        if (!currentStyles) {
            currentStyles = '';
        }
        // process animation silently (don't animate things above the scrolled fold)
        if (domBounds.top < 0 && !blockEles[i].hasAttribute('data-animate')) {
            blockEles[i].setAttribute('data-animate','true');
            blockEles[i].setAttribute('style', currentStyles + '; transition-delay: 0s; animation-delay: 0s;');
        }
        // animate if in the viewport and if data animate is not already set
        if (domBounds.top <= ( domHeight - domNegate ) && !blockEles[i].hasAttribute('data-animate')) {

            // largest paint check (reset delay to 0)
            if (blockEles[i].classList.contains('fmp')) {
                delayCounter = 0.01;
            }

            blockEles[i].setAttribute('data-animate','true');
            blockEles[i].setAttribute('style', currentStyles + 'transition-delay: ' + delayCounter + 's; animation-delay: ' + delayCounter + 's;');
            setTimeout(function(){ 
                if (blockEles[i]) {
                    blockEles[i].classList.remove('animate');
                }
            }, delayCounter);
            delayCounter = delayCounter + 0.15; // 0.15s increase per animation
        }
    }
}

// scrollIt
function scrollToTarget(hash) {
    const id = hash.split('#')[1];
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
        const headerOffset = document.getElementById('header').clientHeight;
        var elementBounds = target.getBoundingClientRect();
        // if the anchor has no height, go to the parent
        if (elementBounds.height == 0) {
            elementBounds = target.parentNode.getBoundingClientRect();
        }
        var elementPosition = document.documentElement.scrollTop + elementBounds.top - headerOffset;
        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
}

// anchor links
if (document.querySelectorAll('.scrollLink, .article-content a[href^="#"]')) {
    document.querySelectorAll('.scrollLink, .article-content  a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const hash = this.getAttribute('href');
            window.history.pushState(this.dataset.link, this.innerText, hash);
            scrollToTarget(hash); 
        });
    });
}